import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { BankStages } from '../../models/Bank';
import { setActiveBankState, useLayoutDispatch } from '../../redux';
import { AppBackButton } from '../AppBackButton';
import {
	StyledButtonContainer,
	StyledButtonContent,
	StyledFine,
	StyledFinesContainer,
	StyledHead,
	StyledNoFinesText,
} from './AppBankFines.styled';

const AppBankFines = () => {
	const dispatch = useLayoutDispatch();
	const fines = true;
	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<div>
			<StyledHead>
				<AppBackButton
					onClick={() => dispatch(setActiveBankState(BankStages.MAIN))}
				/>
				<Text>Штрафы</Text>
			</StyledHead>
			<StyledFinesContainer tabIndex={-1}>
				{fines ? (
					new Array(10).fill(null).map((_, index) => (
						<StyledFine key={index}>
							<Text>Штраф #82391</Text>
							<Text>1000</Text>
							<CurrencyIcon icon={rubleIcon} size="sm" />
						</StyledFine>
					))
				) : (
					<StyledNoFinesText>
						Вы примерный гражданин!
						<br />У вас нет не одного штрафа!
					</StyledNoFinesText>
				)}
			</StyledFinesContainer>
			<StyledButtonContainer>
				<Button
					color={ButtonColors.Select}
					height={ButtonHeight.Height60}
					style={{ fontSize: 18 }}
					disabled={!fines}
				>
					{fines ? (
						<StyledButtonContent>
							<Text>Оплатить</Text>
							<CurrencyIcon icon={rubleIcon} size="lg" />
							<Text>24 500</Text>
						</StyledButtonContent>
					) : (
						<Text>У вас нет штрафов</Text>
					)}
				</Button>
			</StyledButtonContainer>
		</div>
	);
};

export { AppBankFines };
